import { stockAnalysisData, stockFilters } from '../data/stockData';
import { newsData, newsFilters } from '../data/newsData';
import { forumData } from '../data/forumData';
import { manipulationData } from '../data/manipulationData';
import axios from 'axios';

// API基础URL
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.resources-free.com';



// 是否使用模拟数据
// const useMockData = process.env.REACT_APP_USE_MOCK_DATA === 'true';
// const useMockData = process.env.REACT_APP_USE_MOCK_DATA === 'false';
const useMockData = false


// 模拟延迟
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// 获取JWT令牌
const getToken = () => localStorage.getItem('token');

// 通用请求函数
const request = async (url, options = {}) => {
  console.log(`发起请求: ${url}`, options);
  
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const config = {
    ...options,
    headers
  };
  
  try {
    console.log(`请求URL: ${API_BASE_URL}${url}`, config);
    const response = await fetch(`${API_BASE_URL}${url}`, config);
    
    // 尝试解析响应
    let data;
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      data = await response.json();
    } else {
      data = await response.text();
      try {
        // 尝试将文本解析为JSON
        data = JSON.parse(data);
      } catch (e) {
        // 如果不是JSON，保持文本格式
        console.log('响应不是JSON格式:', data);
      }
    }
    
    console.log(`响应状态: ${response.status}`, data);
    
    if (!response.ok) {
      throw new Error(data.message || `请求失败，状态码: ${response.status}`);
    }
    
    return { success: true, data };
  } catch (error) {
    console.error('API请求错误:', error);
    return { success: false, error: error.message };
  }
};

// 认证相关API
export const authApi = {
  // 用户登录
  login: async (email, password) => {
    if (useMockData) {
      await delay(500);
      return { 
        success: true, 
        message: '登录成功', 
        data: {
          token: 'mock-token-' + Math.random().toString(36).substring(2),
          user: {
            id: 1,
            username: '测试用户',
            email: email,
            avatar: 'https://via.placeholder.com/60x60',
            level: '高级会员',
            subscriptions: {
              suck: true,
              wash: true,
              rise: false,
              sell: false
            }
          }
        }
      };
    }
    
    return request('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password })
    });
  },
  
  // 用户注册
  register: async (username, email, password) => {
    if (useMockData) {
      await delay(700);
      return { 
        success: true, 
        message: '注册成功', 
        data: {
          token: 'mock-token-' + Math.random().toString(36).substring(2),
          user: {
            id: 1,
            username: username,
            email: email,
            avatar: 'https://via.placeholder.com/60x60',
            level: '普通会员',
            subscriptions: {
              suck: false,
              wash: false,
              rise: false,
              sell: false
            }
          }
        }
      };
    }
    
    return request('/auth/register', {
      method: 'POST',
      body: JSON.stringify({ username, email, password })
    });
  }
};

// 股票分析相关API
export const stockApi = {
  // 获取热门股票
  getHotStocks: async () => {
    if (useMockData) {
      await delay(300);
      return { success: true, data: stockAnalysisData.hotStocks };
    }
    
    return request('/api/stocks/hot');
  },
  
  // 获取行业板块数据
  getSectors: async () => {
    if (useMockData) {
      await delay(300);
      return { success: true, data: stockAnalysisData.sectors };
    }
    
    return request('/api/stocks/sectors');
  },
  
  // 获取股票详情
  getStockDetail: async (code) => {
    if (useMockData) {
      await delay(500);
      return { success: true, data: stockAnalysisData.stockDiagnosis };
    }
    
    return request(`/api/stocks/${code}`);
  },
  
  // 获取股票诊断数据
  getStockDiagnosis: async (id) => {
    if (useMockData) {
      await delay(500);
      return { success: true, data: stockAnalysisData.stockDiagnosis };
    }
    
    return request(`/api/stocks/diagnosis/${id}`);
  },
  
  // 获取庄家操作阶段数据
  getManipulationPhases: async (phase) => {
    if (useMockData) {
      await delay(400);
      const phases = stockAnalysisData.manipulationPhases;
      if (phase && phases[phase]) {
        return { success: true, data: phases[phase] };
      }
      return { success: true, data: phases };
    }
    
    return request(`/api/stocks/manipulation/phases${phase ? `?phase=${phase}` : ''}`);
  },
  
  // 获取操纵手法数据
  getManipulationTechniques: async (category) => {
    if (useMockData) {
      await delay(400);
      const techniques = manipulationData.techniques;
      if (category && techniques[category]) {
        return { success: true, data: techniques[category] };
      }
      return { success: true, data: techniques };
    }
    
    return request(`/api/stocks/manipulation/techniques${category ? `?category=${category}` : ''}`);
  },
  
  // 获取操纵手法识别指标
  getManipulationIndicators: async (type) => {
    if (useMockData) {
      await delay(300);
      const indicators = manipulationData.indicators;
      if (type && indicators[type]) {
        return { success: true, data: indicators[type] };
      }
      return { success: true, data: indicators };
    }
    
    return request(`/api/stocks/manipulation/indicators${type ? `?type=${type}` : ''}`);
  },
  
  // 获取股票筛选条件
  getStockFilters: async () => {
    if (useMockData) {
      await delay(200);
      return { success: true, data: stockFilters };
    }
    
    return request('/api/stocks/filters');
  },
  
  // 搜索股票
  searchStocks: async (keyword) => {
    if (useMockData) {
      await delay(300);
      const results = stockAnalysisData.hotStocks.filter(stock => 
        stock.code.includes(keyword) || stock.name.includes(keyword)
      );
      return { success: true, data: results };
    }
    
    return request(`/api/stocks/search?keyword=${encodeURIComponent(keyword)}`);
  }
};

// 新闻相关API
export const newsApi = {
  // 获取热门新闻
  getHotNews: async () => {
    if (useMockData) {
      await delay(300);
      return { success: true, data: newsData.hotNews };
    }
    
    return request('/api/news/hot');
  },
  
  // 获取财经日历
  getFinancialCalendar: async () => {
    if (useMockData) {
      await delay(300);
      return { success: true, data: newsData.financialCalendar };
    }
    
    return request('/api/news/calendar');
  },
  
  // 获取新闻分类
  getNewsCategories: async () => {
    if (useMockData) {
      await delay(200);
      return { success: true, data: newsData.categories };
    }
    
    return request('/api/news/categories');
  },
  
  // 获取分类新闻
  getNewsByCategory: async (category) => {
    if (useMockData) {
      await delay(400);
      if (category && newsData.newsByCategory[category]) {
        return { success: true, data: newsData.newsByCategory[category] };
      }
      // 如果没有指定分类或分类不存在，返回热门新闻
      return { success: true, data: newsData.hotNews };
    }
    
    return request(`/api/news${category ? `?category=${category}` : ''}`);
  },
  
  // 获取新闻详情
  getNewsDetail: async (id) => {
    if (useMockData) {
      await delay(500);
      // 这里简化处理，实际应该根据ID查找对应新闻
      return { success: true, data: newsData.newsDetail };
    }
    
    return request(`/api/news/${id}`);
  },
  
  // 获取新闻筛选条件
  getNewsFilters: async () => {
    if (useMockData) {
      await delay(200);
      return { success: true, data: newsFilters };
    }
    
    return request('/api/news/filters');
  },
  
  // 搜索新闻
  searchNews: async (keyword) => {
    if (useMockData) {
      await delay(300);
      const results = newsData.hotNews.filter(news => 
        news.title.includes(keyword) || news.summary.includes(keyword)
      );
      return { success: true, data: results };
    }
    
    return request(`/api/news/search?keyword=${encodeURIComponent(keyword)}`);
  }
};

// 论坛相关API
export const forumApi = {
  // 获取热门话题
  getHotTopics: async () => {
    if (useMockData) {
      await delay(300);
      return { success: true, data: forumData.hotTopics };
    }
    
    return request('/api/forum/topics/hot');
  },
  
  // 获取论坛分类
  getForumCategories: async () => {
    if (useMockData) {
      await delay(200);
      return { success: true, data: forumData.categories };
    }
    
    return request('/api/forum/categories');
  },
  
  // 获取活跃用户
  getActiveUsers: async () => {
    if (useMockData) {
      await delay(300);
      return { success: true, data: forumData.activeUsers };
    }
    
    return request('/api/forum/users/active');
  },
  
  // 获取帖子详情
  getPostDetail: async (id) => {
    if (useMockData) {
      await delay(500);
      // 这里简化处理，实际应该根据ID查找对应帖子
      return { success: true, data: forumData.postDetail };
    }
    
    return request(`/api/forum/posts/${id}`);
  },
  
  // 获取论坛筛选条件
  getForumFilters: async () => {
    if (useMockData) {
      await delay(200);
      return { success: true, data: forumData.forumFilters };
    }
    
    return request('/api/forum/filters');
  },
  
  // 搜索帖子
  searchPosts: async (keyword) => {
    if (useMockData) {
      await delay(300);
      const results = forumData.hotTopics.filter(topic => 
        topic.title.includes(keyword) || topic.tags.some(tag => tag.includes(keyword))
      );
      return { success: true, data: results };
    }
    
    return request(`/api/forum/posts/search?keyword=${encodeURIComponent(keyword)}`);
  },
  
  // 发表评论
  postComment: async (postId, comment) => {
    if (useMockData) {
      await delay(400);
      return { 
        success: true, 
        message: '评论发表成功', 
        data: {
          id: Date.now(),
          author: '当前用户',
          avatar: 'https://via.placeholder.com/40x40',
          content: comment,
          date: new Date().toISOString(),
          likes: 0,
          replies: []
        }
      };
    }
    
    return request(`/api/forum/posts/${postId}/comments`, {
      method: 'POST',
      body: JSON.stringify({ content: comment })
    });
  }
};

// 用户相关API
export const userApi = {
  // 获取用户信息
  getUserInfo: async () => {
    if (useMockData) {
      await delay(300);
      // 模拟获取用户信息
      return { 
        success: true, 
        data: {
          id: 1,
          username: '测试用户',
          email: 'test@example.com',
          avatar: 'https://via.placeholder.com/60x60',
          level: '高级会员',
          subscriptions: {
            suck: true,
            wash: true,
            rise: false,
            sell: false
          },
          registerDate: '2023-01-15',
          lastLoginDate: '2023-07-16'
        }
      };
    }
    
    return request('/api/user/profile');
  },
  
  // 获取用户订阅信息
  getUserSubscriptions: async () => {
    if (useMockData) {
      await delay(300);
      return { 
        success: true, 
        data: {
          suck: true,
          wash: true,
          rise: false,
          sell: false,
          expiryDate: '2023-12-31'
        }
      };
    }
    
    return request('/api/user/subscriptions');
  },
  
  // 更新用户信息
  updateUserInfo: async (userData) => {
    if (useMockData) {
      await delay(500);
      return { 
        success: true, 
        message: '用户信息更新成功', 
        data: {
          ...userData,
          id: 1
        }
      };
    }
    
    return request('/api/user/profile', {
      method: 'PUT',
      body: JSON.stringify(userData)
    });
  }
};

// 支付相关API
export const paymentApi = {
  // 创建订单
  createOrder: async (productData,token) => {
    console.log('createOrder API 被调用，参数:', productData);
    
    if (useMockData) {
      await delay(500);
      console.log('使用模拟数据创建订单');
      
      // 确保返回正确的模拟数据结构
      const mockResponse = { 
        success: true, 
        message: '订单创建成功', 
        data: {
          orderId: 'ORD' + Date.now(),
          amount: productData.price || 99,
          productName: productData.name || '订阅计划',
          createTime: new Date().toISOString(),
          paymentUrl: 'https://example.com/payment/qr/12345',
          qrCodeUrl: 'https://via.placeholder.com/200x200?text=支付二维码'
        }
      };
      
      console.log('模拟订单创建响应:', mockResponse);
      return mockResponse;
    }
    
    try {
      console.log('发送真实支付请求');
      // 修复请求参数格式，确保productId是字符串类型
      const requestBody = {
        productId: String(productData.id),
        subscriptionType: productData.period === 'monthly' ? 'MONTHLY' : 'YEARLY'
      };
      
      console.log('请求体:', requestBody);
      
      const response = await request('/api/payments/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(requestBody)
      });
      
      console.log('支付API响应:', response);
      return response;
    } catch (error) {
      console.error('支付请求错误:', error);
      return { 
        success: false, 
        error: error.message || '创建订单失败，请稍后再试' 
      };
    }
  },
  
  // 查询订单状态
  queryOrderStatus: async (orderId) => {
    console.log('查询订单状态, 订单ID:', orderId);
    
    if (useMockData) {
      await delay(300);
      // 模拟订单状态
      return { 
        success: true, 
        data: {
          orderId: orderId,
          status: 'paid', // unpaid, paid, cancelled
          paidTime: new Date().toISOString(),
          productName: '高级会员月度订阅',
          amount: 299
        }
      };
    }
    
    return request(`/api/payments/orders/${orderId}`);
  },
  
  // 取消订单
  cancelOrder: async (orderId) => {
    if (useMockData) {
      await delay(300);
      return { 
        success: true, 
        message: '订单已取消', 
        data: {
          orderId: orderId,
          status: 'cancelled'
        }
      };
    }
    
    return request(`/api/payments/orders/${orderId}/cancel`, {
      method: 'POST'
    });
  },
  
  // 获取支付方式
  getPaymentMethods: async () => {
    if (useMockData) {
      await delay(200);
      return { 
        success: true, 
        data: [
          { id: 1, name: '微信支付', icon: 'wechat' },
          { id: 2, name: '支付宝', icon: 'alipay' },
          { id: 3, name: '银联', icon: 'unionpay' }
        ]
      };
    }
    
    return request('/api/payments/methods');
  },
  
  // 获取会员套餐
  getMembershipPlans: async (moduleId) => {
    if (useMockData) {
      await delay(300);
      return { 
        success: true, 
        data: [
          { id: 1, name: '基础会员', price: 99, period: 'monthly', features: ['吸筹阶段'] },
          { id: 2, name: '高级会员', price: 299, period: 'monthly', features: ['吸筹阶段', '洗盘阶段', '拉升阶段'] },
          { id: 3, name: 'VIP会员', price: 999, period: 'monthly', features: ['吸筹阶段', '洗盘阶段', '拉升阶段', '出货阶段'] }
        ]
      };
    }
    
    return request(`/api/modules/pricing?module=${moduleId}`);
  }
};

// 产品相关API
export const productApi = {
  // 获取产品列表
  getProducts: async (module) => {
    console.log('获取产品列表, 模块:', module);
    
    if (useMockData) {
      await delay(300);
      
      // 确保返回正确的模拟数据结构
      const mockProducts = [
        { 
          id: 1, 
          name: '基础会员', 
          price: 99, 
          period: 'monthly', 
          module: module || 'suck',
          features: ['每日精选股票推荐', '基础选股功能', '技术指标参考']
        },
        { 
          id: 2, 
          name: '高级会员', 
          price: 299, 
          period: 'monthly', 
          module: module || 'suck',
          features: ['不限股票查看数量', '全部高级功能', '历史数据查询', '环比数据分析']
        },
        { 
          id: 3, 
          name: 'VIP会员', 
          price: 999, 
          period: 'monthly', 
          module: module || 'suck',
          features: ['高级会员全功能', '提前获得预警', '一对一咨询服务']
        }
      ];
      
      console.log('返回模拟产品数据:', mockProducts);
      return { 
        success: true, 
        data: mockProducts
      };
    }
    
    try {
      const response = await request(`/api/products${module ? `?module=${module}` : ''}`);
      console.log('产品API响应:', response);
      return response;
    } catch (error) {
      console.error('获取产品列表错误:', error);
      return { 
        success: false, 
        error: error.message || '获取产品列表失败，请稍后再试' 
      };
    }
  }
};

// 推荐相关API
// 推荐相关API
// 推荐相关API
export const recommendationApi = {
  // 获取推荐模块列表
  getModules: async () => {
    console.log('获取推荐模块列表');
    return await request('/api/recommendations/modules');
  },
  
  // 获取模块内容
  getModuleContent: async (moduleId, date) => {
    console.log(`获取模块内容: moduleId=${moduleId}, date=${date}`);
    
    // 检查是否使用模拟数据
    if (process.env.REACT_APP_USE_MOCK_DATA === 'true') {
      console.log('使用模拟数据');
      
      // 模拟延迟
      await new Promise(resolve => setTimeout(resolve, 800));
      
      // 根据模块ID返回不同的模拟数据
      const mockItems = Array(15).fill().map((_, index) => ({
        id: `${moduleId}-${index + 1}`,
        code: `${600000 + index}`,
        name: `示例股票${index + 1}`,
        stockType: index % 3 === 0 ? '主板' : (index % 3 === 1 ? '创业板' : '科创板'),
        recommendPrice: 10 + Math.random() * 90,
        targetPrice: 15 + Math.random() * 100,
        expectedYield: `+${(Math.random() * 20 + 5).toFixed(2)}%`,
        reason: `这是${moduleId}阶段的推荐理由示例，包含技术分析和基本面分析。`
      }));
      
      return {
        success: true,
        data: {
          items: mockItems,
          rankingCount: mockItems.length,
          date: date
        }
      };
    }
    
    // 实际API调用，修改 URL 为后端定义的接口路径
    try {
      const response = await request(`/api/modules/content?module=${moduleId}&date=${date}`);
      return {
        success: true,
        data: response
      };
    } catch (error) {
      console.error('获取模块内容失败:', error);
      return {
        success: false,
        error: error.message || '获取模块内容失败'
      };
    }
  }
};


